import type { CoupleFlowState } from '../../../hooks/useCoupleFlow';

export type CoupleStepStatus = 'done' | 'active' | 'pending';

/**
 * Progress-chip statuses for the couple-portrait generation screen, derived from
 * the REAL flow state — not wall-clock timers. The backend exposes no generation
 * sub-phase, so we never claim a step is "done" until the portrait is actually
 * completed; during generation the first chip shows active and the rest pending.
 * (Replaces the old fake 5s/15s `doneAfterMs` timers — 2026-06-12 audit.)
 */
export function coupleStepStatuses(state: CoupleFlowState, count: number): CoupleStepStatus[] {
  if (state === 'completed') {
    return Array.from({ length: count }, () => 'done' as const);
  }
  if (state === 'generating' || state === 'both_confirmed') {
    return Array.from({ length: count }, (_, i) => (i === 0 ? 'active' : 'pending'));
  }
  return Array.from({ length: count }, () => 'pending' as const);
}
